import { render, staticRenderFns } from "./BookingSuggestionDialog.vue?vue&type=template&id=64f38958"
import script from "./BookingSuggestionDialog.vue?vue&type=script&lang=js"
export * from "./BookingSuggestionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports